var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"title":_vm.$route.name,"rotas":_vm.rotas}},[_c('Desktop',{attrs:{"local":_vm.local,"payment_sys_config":_vm.payment_sys_config,"payment_menurocket_config":_vm.payment_menurocket_config,"receipt":_vm.receipt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }